import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmployee = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.013 2q2.062 0 3.875.787a10.2 10.2 0 0 1 3.175 2.15 10.2 10.2 0 0 1 2.15 3.175Q22 9.925 22 11.987a9.7 9.7 0 0 1-.787 3.888 10.1 10.1 0 0 1-2.15 3.188 10.2 10.2 0 0 1-3.175 2.15 9.6 9.6 0 0 1-3.875.787 9.7 9.7 0 0 1-3.888-.787 10.15 10.15 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.188A9.7 9.7 0 0 1 2 11.987q0-2.062.787-3.875a10.2 10.2 0 0 1 2.15-3.174 10.1 10.1 0 0 1 3.188-2.15A9.7 9.7 0 0 1 12.013 2M7 9v8h10V9l-5-3zm5 4.667q.906 0 1.758.274a6.4 6.4 0 0 1 1.617.792.73.73 0 0 1 .281.317q.094.2.094.433v.184h-7.5v-.184q0-.233.094-.433a.73.73 0 0 1 .281-.317 6.4 6.4 0 0 1 1.617-.792A5.7 5.7 0 0 1 12 13.667M12 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4" })
});
export default SvgEmployee;
